import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c(VCard,{staticClass:"my-3",attrs:{"rounded":"lg","outlined":"","data-test":"TodoListItemSkeleton"}},[_c(VSkeletonLoader,{attrs:{"type":"list-item-avatar-three-line"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }